import { sendError } from "./utils";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const IS_CONFIG = process.env.REACT_APP_IS_CONFIG;
const keyRegEx = new RegExp("(?:^|; )" + "api-key".replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)");
const API_KEY = document.cookie.match(keyRegEx) && decodeURIComponent(document.cookie.match(keyRegEx)[1]);
const referer = window.location !== window.parent.location ? document.referrer : document.location.href;

export const request = ({ url, method, body, headers, baseURL }) => {
  if (url === undefined) {
    console.error("url for request === undefined");
    return null;
  }
  if (method === undefined) method = "GET";
  if (headers === undefined) headers = {};
  if (IS_CONFIG === "true" && headers["x-api-key"] === undefined) {
    headers["x-api-key"] = API_KEY;
  }
  if (headers["x-parent-referer"] === undefined) headers["x-parent-referer"] = referer || `none`;
  if (baseURL === undefined) baseURL = BASE_URL;

  return fetch(baseURL + url, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    body: body ? body : null,
  });
};

export const getSessionsOfEvent = (id) => {
  return request("/widgets/1.0.0/events/" + id + "/sessions");
};

export const UNAUTHORIZED_EXCEPTION_MESSAGE = "unauthorized";

export const getWeekendData = async (id) => {
  const sessions = await request({
    url: "widgets/1.0.0/events/" + id + "/sessions",
  }).then((r) => {
    if (r.ok) return r.json();
    else {
      if (r.status === 403) {
        sendError({
          name: "unauthorized",
          message: "no valid api-key",
        });
        return UNAUTHORIZED_EXCEPTION_MESSAGE;
      }
      sendError({
        name: "Fetch weekend data error",
        message: "fetch sessions status not ok",
      });
      return null;
    }
  });
  if (sessions === UNAUTHORIZED_EXCEPTION_MESSAGE) return UNAUTHORIZED_EXCEPTION_MESSAGE;
  if (sessions === null) {
    sendError({ name: "Fetch weekend data error", message: "no sessions" });
    return null;
  }

  const requests = sessions
    .filter((session) => session.status !== "Cancelled")
    .map((session) => {
      const urls = [
        "widgets/1.0.0/sessions/" + session.uuid,
        "widgets/1.0.0/sessions/" + session.uuid + "/classification",
      ];
      return Promise.all(
        urls.map((url) => {
          return request({ url })
            .then((r) => r.json())
            .catch(() => null);
        })
      );
    });
  return Promise.all(requests).then((r) => r.map((d) => ({ sessionInfo: d[0], data: d[1] })));
};
export const getRaceData = async (id) => {
  const sessions = await request({
    url: "widgets/1.0.0/events/" + id + "/sessions",
  }).then((r) => {
    if (r.ok) return r.json();
    else {
      if (r.status === 403) {
        sendError({
          name: "unauthorized",
          message: "no valid api-key",
        });
        return UNAUTHORIZED_EXCEPTION_MESSAGE;
      }
      sendError({
        name: "Fetch race data error",
        message: "fetch status not ok",
      });
      return null;
    }
  });
  if (sessions === UNAUTHORIZED_EXCEPTION_MESSAGE) return UNAUTHORIZED_EXCEPTION_MESSAGE;
  if (sessions === null || sessions.length === 0) {
    sendError({ name: "Fetch race data error", message: "no sessions" });
    return null;
  }
  const raceId = sessions.find((s) => s.isFinal)?.uuid;
  const urls = [
    "widgets/1.0.0/sessions/" + raceId,
    "widgets/1.0.0/sessions/" + raceId + "/raceHistory",
    "widgets/1.0.0/sessions/" + raceId + "/classification",
  ];
  const src = await Promise.all(
    urls.map((url) =>
      request({ url })
        .then((r) => r.json())
        .catch((error) => ({ error }))
    )
  );
  const [raceMeta, race, finish] = src;
  return { raceMeta, race, finish };
};
export const getChampionshipData = async (uuid) => {
  const url = "widgets/1.0.0/seasons/" + uuid + "/standings/drivers/details";
  return request({ url })
    .then((r) => {
      if (r.ok) return r.json();
      else {
        if (r.status === 403) {
          sendError({
            name: "unauthorized",
            message: "no valid api-key",
          });
          return UNAUTHORIZED_EXCEPTION_MESSAGE;
        }
        sendError({
          name: "Fetch championship data error",
          message: "fetch status not ok",
        });
        return null;
      }
    })
    .catch((error) => {
      console.error(error);
      sendError(error);
      return null;
    });
};
export const getProfileData = async (id) => {
  const urls = [
    "web/3.0.0/drivers/" + id + "/short",
    "web/3.0.0/drivers/" + id + "/series/results",
    "web/3.0.0/drivers/" + id + "/seasons",
    "web/3.0.0/drivers/" + id + "/seasonsByTeams",
    // 'web/3.0.0/drivers/' + id + '/stats',
  ];

  const headers = process.env.REACT_APP_MSS_API_KEY ? { "x-api-key": process.env.REACT_APP_MSS_API_KEY } : {};

  const requests = urls.map((url) =>
    request({
      url,
      headers,
    })
      .then((r) => r.json())
      .catch((error) => ({ error }))
  );
  return Promise.all(requests);
};
export const getBasicData = async (id, stat) => {
  const url = `widgets/1.0.0/series/${id}/history/drivers?stats=` + stat;
  return request({ url })
    .then((r) => {
      if (r.ok) return r.json();
      else {
        sendError({
          name: "Fetch basic data error",
          message: "fetch status not ok",
        });
        return null;
      }
    })
    .catch((error) => {
      console.error(error);
      sendError(error);
      return null;
    });
};

export const getAllSeries = () => {
  return request({ url: "widgets/1.0.0/series" })
    .then((r) => r.json())
    .then((r) => r.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)))
    .catch((e) => console.error(e));
};
export const getAllSeasons = (id) => {
  return request({ url: "widgets/1.0.0/series/" + id + "/seasons" })
    .then((r) => r.json())
    .then((r) => r.sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? 1 : -1)))
    .catch((e) => console.error(e));
};
export const getAllEvents = (id) => {
  return request({ url: "widgets/1.0.0/seasons/" + id + "/events" })
    .then((r) => r.json())
    .then((r) => r.filter((e) => e.status !== "Cancelled"))
    .then((r) => r.sort((a, b) => (a.startDate > b.startDate ? 1 : -1)))
    .catch((e) => console.error(e));
};

export const getLastSeasonsId = async (seriesId) => {
  const seasons = await request({
    url: "widgets/1.0.0/series/" + seriesId + "/seasons?hasStandings=true",
  })
    .then((r) => {
      if (r.ok) return r.json();
      else return null;
    })
    .catch((e) => console.error(e));
  if (seasons === null || seasons.length === 0) return "series=" + seriesId;
  return seasons[0].uuid;
};
export const getLastEventsId = async (seriesId) => {
  const lastSession = await request({
    url: `widgets/1.0.0/sessions/last?seriesUuid=${seriesId}&isFinal=true&hasClassification=true`,
  })
    .then((r) => {
      if (r.ok) return r.json();
      else return null;
    })
    .catch((e) => console.error(e));
  if (lastSession === null) return "series=" + seriesId;
  else return lastSession.event.uuid;
};

export const getThemeNames = () => {
  return request({ url: "widgets/1.0.0/themes/names" })
    .then((r) => r.json())
    .catch((e) => console.error(e));
};
export const getTheme = (name) => {
  if (name) {
    return request({ url: "widgets/1.0.0/themes/byName/" + name })
      .then((r) => r.json())
      .catch((e) => console.error(e));
  }
};
export const saveTheme = (name, data, isNew = true) => {
  return request({
    url: "widgets/1.0.0/themes",
    method: isNew ? "POST" : "PUT",
    body: JSON.stringify({ name, data }),
  });
};
// export const deleteTheme = (user, name) => {
//   return fetch(`https://f1-informer.com/api/widget?user=${user}&name=${name}`, {
//     headers: {},
//     method: 'DELETE'
//   })
// }
